<mat-menu #contextMenu="matMenu">
  <ng-template matMenuContent>
    @for (opt of menuOptions; track opt) {
      <button (click)="opt.onClick($event)" mat-menu-item>
        <mat-icon>{{ opt.icon }}</mat-icon>
        <span>{{ opt.text | translate }}</span>
      </button>
    }
    @if (!menuOptions?.length) {
      <button [disabled]="true" mat-menu-item>
        <span>Nichts zu tun.</span>
      </button>
    }
  </ng-template>
</mat-menu>

@if (!isRightClick) {
  <button
    (click)="$event.stopPropagation()"
    [disabled]="!menuOptions?.length"
    [matMenuTriggerFor]="contextMenu"
    mat-icon-button
    >
    <mat-icon>more_horiz</mat-icon>
  </button>
}

@if (isRightClick) {
  <div
    [matMenuTriggerFor]="contextMenu"
    [style.left]="menuTopLeftPosition.x"
    [style.top]="menuTopLeftPosition.y"
    style="visibility: hidden; position: fixed"
  ></div>
}
